import { EmailService } from "../EmailService/email.service"
import { EmailDelegate } from "../EmailService/email.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class EmailServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService): EmailService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new EmailDelegate(config, httpProvider);
        return new EmailService(delegate);
    }
}